import { Box, Button, Grid, Input, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import KenGrid from '../../../../../../global_components/KenGrid';
import KenInputField from '../../../../../../global_components/KenInputField';
import {
  getCreateGradeRange,
  getDefaultGradeRangerDatas,
  postDefualtGradeSetup,
} from '../../../../../../Utils/apiServices';
// import { LineChart } from './LineChart';
//  Add the Colum name

const columnGrad = [
  {
    Header: 'ID',
    accessor: 'id',
    disableGlobalFilter: true,
  },
  {
    Header: 'Marks Range',
    accessor: 'percentile',
    disableGlobalFilter: true,
  },
  {
    Header: 'Grade Point',
    accessor: 'cgpa',
    disableGlobalFilter: true,
  },

  {
    Header: 'Letter Grade ',
    accessor: 'grade_name',
    disableGlobalFilter: true,
    // Cell: QuestionPaperCell,
  },
];

const DefaultGradingAbsolute = () => {
  const [objSlider, setObjSlider] = useState();

  const [columnGridAbsolute, setColumnGridAbsolute] = useState(columnGrad);
  const [columnGridAbsolute1, setColumnGridAbsolute1] = useState(columnGrad);

  const cgpaCell = (rows, i) => {
    return (
      <Box>
        <Grid item xs={12} sm={3}>
          <KenInputField
            name={rows}
            optionalLabel={false}
            value={rows}
            dropdownColor="#ffffff"
            // onChange={(e) => handleChangeCgpa(e, rows, i)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      </Box>
    );
  };

  const handleChangeSlider = (e, index) => {
    let valueSlider = e.target.value.split('-');
    const arrData = valueSlider.map((ele) => parseInt(ele));
    if (!Array.isArray(arrData)) {
      return;
    }
    if (true) {
      setObjSlider((prevState) => {
        return prevState.map((single, i) => {
          if (i === index) {
            return { ...single, value: [arrData[0] || 0, arrData[1] || 0] };
          } else {
            return single;
          }
        });
      });
    }
  };

  const dataGrad = objSlider?.map((ele, i) => {
    return {
      id: i + 1,
      percentile: (
        <Grid item xs={12} sm={4}>
          <KenInputField
            optionalLabel={false}
            value={ele.value.join(' - ')}
            onChange={(e, value) => handleChangeSlider(e, i, value, 0)}
            // onBlur={() => handleOnBlur()}
            style={{ fontSize: 12 }}
          />
        </Grid>
      ),
      cgpa: cgpaCell(ele.cgpa, i),
      grade_name: cgpaCell(ele.grade, i),
    };
  });

  const postData = () => {
    const data = objSlider?.map((item) => {
      return {
        recordId: item.id,
        typeOfGrading: 'Absolute',
        letterGrade: item.grade,
        upperPercentageLimit: item.value[0],
        lowerPercentageLimit: item.value[1],
        upperPercentileLimit: null,
        lowerPercentileLimit: null,
      };
    });

    postDefualtGradeSetup(data)
      .then((res) => {
        DefaultGrade();
        console.log('getGradingCourseDetails', res);
      })
      .catch((err) => {
        console.log('Grading Course Details error', err);
      });
  };

  const DefaultGrade = () => {
    getCreateGradeRange().then((res) => {
      console.log('resresresresresresresres', res[0].gradeRangeWrapper);
      const finalData =
        res == null
          ? []
          : res[0]?.gradeRangeWrapper?.map((item, index) => {
              console.log('itemitemitemitemitemitem-----', item);
              // const myArray = item.markRange.split('-');
              const myArray = [item.maximumMark, item.minimumMark];
              return {
                id: item.id,
                value: myArray,
                cgpa: item.gradePoint,
                grade: item.letterGrade,
              };
            });
      setObjSlider(finalData);
    });
  };

  useEffect(() => {
    DefaultGrade();
  }, []);
  // const [content, setContent] = useState([]);

  // const handleAddClick = () => {
  //   setContent([
  //     ...content,
  //     // <Grid container spacing={2}>
  //     //   {/* <Grid item xs={12} sm={4}>
  //     //     <KenInputField
  //     //       // name={rows}
  //     //       optionalLabel={false}
  //     //       // value={rows}
  //     //       dropdownColor="#ffffff"
  //     //       // onChange={(e) => handleChangeCgpa(e, rows, i)}
  //     //       style={{ fontSize: 12 }}
  //     //     />
  //     //   </Grid> */}
  //     //   {/* <Grid item xs={12} sm={4}>
  //     //     <TextField
  //     //       variant="outlined"
  //     //       optionalLabel={false} */}
  //     //   {/* value={ele.value.join(' - ')}
  //     //       onChange={(e, value) => handleChangeSlider(e, i, value, 0)}
  //     //       onBlur={() => handleOnBlur()} */}
  //     //   {/* style={{ fontSize: 12, width: '100px' }}
  //     //     />
  //     //   </Grid> */}
  //     //   {/* <Grid item xs={12} sm={4}>
  //     //     <KenInputField
  //     //       // name={rows}
  //     //       optionalLabel={false}
  //     //       // value={rows}
  //     //       dropdownColor="#ffffff"
  //     //       // onChange={(e) => handleChangeCgpa(e, rows, i)}
  //     //       style={{ fontSize: 12 }}
  //     //     />
  //     //   </Grid> */}
  //     // </Grid>,
  //   ]);
  // };
  return (
    <div>
      <Box>
        {' '}
        <div>
          {' '}
          <div style={{ textTransform: 'uppercase', textAlign: 'center' }}>
            <b>Default Grading : Absolute </b>
          </div>{' '}
          <hr />
          <Grid container>
            {/* <Grid xs={5}>
              <LineChart />
            </Grid> */}
            <Grid xs={12}>
              <KenGrid
                columns={columnGridAbsolute}
                data={dataGrad}
                pagination={{ disabled: true }}
                toolbarDisabled={true}
                initialState={{
                  hiddenColumns: ['id'],
                }}
              />
              {/* {content} */}
              {/* <Button
                variant="contained"
                onClick={handleAddClick}
                color="primary"
                style={{ marginRight: '15px' }}
                // className={classes.addButton}
              >
                Add Row
              </Button> */}
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: '15px' }}
                // className={classes.addButton}
                onClick={() => {
                  postData();
                }}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </div>
      </Box>
    </div>
  );
};

export default DefaultGradingAbsolute;
